import { render, staticRenderFns } from "./homeCourseItem.vue?vue&type=template&id=fbf5cdf4&scoped=true&"
import script from "./homeCourseItem.vue?vue&type=script&lang=js&"
export * from "./homeCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./homeCourseItem.vue?vue&type=style&index=0&id=fbf5cdf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf5cdf4",
  null
  
)

export default component.exports